const PATHS = {
  MENU: "/menu",
  MOVIES: "/movies",
  MOVIE_INFO: "/movie/:id",
  FAVORITES: "/favorites",
  SEARCH: "/search",
  LIVE: "/live",
  APPS: "/apps",
  ACTIVATION_PAGE: "/activation-page",

  SETTINGS: "/settings",

  SPLASH_SCREEN: "/",
};

export default PATHS;
